import { AspectRatio, Image, AspectRatioProps } from "@chakra-ui/react";
import { filestoreUrl, publicUrl } from "config";
import { ImageSize } from "types";

type FancyBearImageProps = Omit<AspectRatioProps, "ratio"> & {
  tokenId: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const FancyBearImage = ({
  tokenId,
  size = "512",
  isDisabled = false,
  ...rest
}: FancyBearImageProps) => (
  <AspectRatio ratio={1} w="full" {...rest} bg="bright.600">
    <Image
      src={`${filestoreUrl}/${size}/${tokenId}.png`}
      fallbackSrc={`${publicUrl}/bear-placeholder_transparent.png`}
      fit="cover"
      opacity={isDisabled ? 0.5 : 1}
      transition="opacity 0.15s"
    />
  </AspectRatio>
);

export default FancyBearImage;
